// services/baseService.ts
import { apiClient } from '../config/api';
import { QueryParams, buildQueryString, ApiResponse, PaginatedResponse } from '../config/endpoints';

export abstract class BaseService<T> {
  protected abstract endpoints: {
    LIST: string;
    CREATE: string;
    SEARCH: string;
    BY_ID: (id: string | number) => string;
    UPDATE: (id: string | number) => string;
    DELETE: (id: string | number) => string;
  };

  // ✅ Listar com paginação
  async list(params?: QueryParams): Promise<PaginatedResponse<T>> {
    const queryString = params ? buildQueryString(params) : '';
    return apiClient.request<PaginatedResponse<T>>(`${this.endpoints.LIST}${queryString}`);
  }

  // ✅ Buscar por termo
  async search(query: string, params?: Omit<QueryParams, 'search'>): Promise<PaginatedResponse<T>> {
    const allParams = { search: query, ...params };
    const queryString = buildQueryString(allParams);
    return apiClient.request<PaginatedResponse<T>>(`${this.endpoints.SEARCH}${queryString}`);
  }

  // ✅ Buscar por ID
  async getById(id: string | number): Promise<ApiResponse<T>> {
    const token = localStorage.getItem('authToken');
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    return apiClient.request<ApiResponse<T>>(this.endpoints.BY_ID(id), { headers });
  }

  // ✅ Criar novo registro
  async create(data: Partial<T>): Promise<ApiResponse<T>> {
    const token = localStorage.getItem('authToken');
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    return apiClient.request<ApiResponse<T>>(this.endpoints.CREATE, {
      method: 'POST',
      body: JSON.stringify(data),
      headers,
    });
  }

  // ✅ Atualizar registro
  async update(id: string | number, data: Partial<T>): Promise<ApiResponse<T>> {
    const token = localStorage.getItem('authToken');
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    return apiClient.request<ApiResponse<T>>(this.endpoints.UPDATE(id), {
      method: 'PUT',
      body: JSON.stringify(data),
      headers,
    });
  }

  // ✅ Deletar registro
  async delete(id: string | number): Promise<ApiResponse<boolean>> {
    const token = localStorage.getItem('authToken');
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    return apiClient.request<ApiResponse<boolean>>(this.endpoints.DELETE(id), {
      method: 'DELETE',
      headers,
    });
  }
}